'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Common.Benchmark', ['AVRO.Common.Configuration']).factory('BenchmarkService', require('./services/BenchmarkService'));